import {IServiceFactory} from "../../../../service-factory.interface";
import {MealSsrBase} from "../meal-ssr-base";

//Meniu Platou Rece
export default class KrmnSsrType extends MealSsrBase {
    constructor(services: IServiceFactory) {
        super('KRMN', services);
    }
}
